(function () {

  /* ============================================
     CONFLICT DATA — must match Page 1's list exactly (same handles,
     same structure). See page-fault-lines.js for the full rationale
     comment on years/renames; kept brief here to avoid duplication
     drifting out of sync in wording (data itself is kept identical).
     ============================================ */
  /* Shopify treats .glb uploads as "3D models," a different media
     type from regular Files — each one gets served from its own
     unique hash path (cdn.shopify.com/3d/models/{random-hash}/...),
     with NO shared base URL across files. Unlike the PNG thumbnails
     (which do share one base + real filename), GLBs need a direct
     handle -> full URL map instead. Confirmed via a full check of
     all 35 uploaded links: every hash is different, no pattern. */
  const GLB_URL = {
    "russia-ukraine": "https://cdn.shopify.com/3d/models/b519e34e3d3f42dd/faultlines_R01_Russia-Ukraine.glb",
    "ethiopia-eritrea": "https://cdn.shopify.com/3d/models/46199553e01155af/faultlines_R02_Ethiopia-Eritrea.glb",
    "yemen": "https://cdn.shopify.com/3d/models/a8c8f04bf048a622/faultlines_R03_Yemen.glb",
    "sudan": "https://cdn.shopify.com/3d/models/075e4912f5db9a5a/faultlines_R04_Sudan.glb",
    "syria": "https://cdn.shopify.com/3d/models/d6b1b9db6c8141ec/faultlines_R05_Syria.glb",
    "pakistan-afghanistan": "https://cdn.shopify.com/3d/models/300ac99617f4d392/faultlines_R06_Pakistan-Afghanistan.glb",
    "mexico": "https://cdn.shopify.com/3d/models/426b04457544bda1/faultlines_R07_Mexico.glb",
    "israel-palestine": "https://cdn.shopify.com/3d/models/98fd97e37d0aae66/faultlines_R09_Israel-Gaza-WestBank.glb",
    "nigeria": "https://cdn.shopify.com/3d/models/967323900f7a483e/faultlines_R10_Nigeria.glb",
    "somalia": "https://cdn.shopify.com/3d/models/047a6ba05196fd33/faultlines_R11_Somalia.glb",
    "myanmar": "https://cdn.shopify.com/3d/models/6e962b1b74b607fd/faultlines_R12_Myanmar.glb",
    "congo-rwanda": "https://cdn.shopify.com/3d/models/e4ab3b7811c5c388/faultlines_R13_Congo-Rwanda.glb",
    "brazil": "https://cdn.shopify.com/3d/models/6e63a9ba50c6d446/faultlines_R14_Brazil.glb",
    "burkina": "https://cdn.shopify.com/3d/models/d0a186097c207394/faultlines_R15_Burkina.glb",
    "colombia": "https://cdn.shopify.com/3d/models/dd80b41ab53c3e2e/faultlines_R16_Colombia.glb",
    "mali": "https://cdn.shopify.com/3d/models/d25fef68b6c64111/faultlines_R17_Mali.glb",
    "haiti-dominican-republic": "https://cdn.shopify.com/3d/models/ccc0cd7e0ad503cf/faultlines_R20_Haiti-Dominica.glb",
    "lebanon-israel": "https://cdn.shopify.com/3d/models/dbddc15df1f1dc5b/faultlines_R22_Lebanon-Israel.glb",
    "cameroon": "https://cdn.shopify.com/3d/models/eb78ff0193ce3346/faultlines_R23_Cameroon.glb",
    "niger": "https://cdn.shopify.com/3d/models/de8ad7836aee4f26/faultlines_R26_Niger.glb",
    "ecuador": "https://cdn.shopify.com/3d/models/3844cb7e28f91bae/faultlines_R28_Equador.glb",
    "mozambique": "https://cdn.shopify.com/3d/models/45433e4de8051c6b/faultlines_R29_Mozambique.glb",
    "iran-israel": "https://cdn.shopify.com/3d/models/e588a3c2c3993cc8/faultlines_R31_Iran-Israel.glb",
    "usa-iran": "https://cdn.shopify.com/3d/models/82ec6fdee015c65a/faultlines_R32_USA-Iran.glb",
    "india-pakistan": "https://cdn.shopify.com/3d/models/c04694ea1a9917de/faultlines_R35_India-Pakistan.glb",
    "usa-venezuela": "https://cdn.shopify.com/3d/models/09c3433e3ff3fb61/faultlines_R36_USA-Venezuela.glb",
    "cambodia-thailand": "https://cdn.shopify.com/3d/models/385d4402baf7764f/faultlines_R42_Cambodia-Thailand.glb",
    "serbia-kosovo": "https://cdn.shopify.com/3d/models/a0bfeb5d8ed34fde/faultlines_R43_Serbia-Kosovo.glb",
    "south-korea-north-korea": "https://cdn.shopify.com/3d/models/5d91849ec400fe68/faultlines_R44_South-Korea-North-Korea.glb",
    "cyprus-turkiye": "https://cdn.shopify.com/3d/models/5c8d337c5118108f/faultlines_R45_Cyprus-Turkiye.glb",
    "china-taiwan": "https://cdn.shopify.com/3d/models/4ee4efc606a2199f/faultlines_R46_China-Taiwan.glb",
    "usa-cuba": "https://cdn.shopify.com/3d/models/5d9c3c8a0cc07248/faultlines_R48_USA-Cuba.glb",
    "usa-greenland": "https://cdn.shopify.com/3d/models/dbf99b1176dacafd/faultlines_R49_USA-Greenland.glb",
    "usa-china": "https://cdn.shopify.com/3d/models/fc86034042fe4f73/faultlines_R50_USA-China.glb",
    "china-india": "https://cdn.shopify.com/3d/models/390efd86aa1a8ccc/faultlines_R51_China-India.glb"
  };
  const THUMB_BASE = "https://cdn.shopify.com/s/files/1/0726/7221/5128/files/";
  const THUMB_SUFFIX = ".png";

  /* Real uploaded filenames don't match our clean handles (they're
     named by rank + original country spelling from the spreadsheet,
     e.g. "faultlines_R01_Russia-Ukraine.glb"). This map translates
     handle -> actual filename (no extension) for both the .glb and
     .png assets, since both use the same base filename. Must stay
     identical to the same map in page-fault-lines.js. */
  const FILE_MAP = {
    "russia-ukraine":              "faultlines_R01_Russia-Ukraine",
    "ethiopia-eritrea":            "faultlines_R02_Ethiopia-Eritrea",
    "yemen":                       "faultlines_R03_Yemen",
    "sudan":                       "faultlines_R04_Sudan",
    "syria":                       "faultlines_R05_Syria",
    "pakistan-afghanistan":        "faultlines_R06_Pakistan-Afghanistan",
    "mexico":                      "faultlines_R07_Mexico",
    "israel-palestine":            "faultlines_R09_Israel-Gaza-WestBank",
    "nigeria":                     "faultlines_R10_Nigeria",
    "somalia":                     "faultlines_R11_Somalia",
    "myanmar":                     "faultlines_R12_Myanmar",
    "congo-rwanda":                "faultlines_R13_Congo-Rwanda",
    "brazil":                      "faultlines_R14_Brazil",
    "burkina":                     "faultlines_R15_Burkina",
    "colombia":                    "faultlines_R16_Colombia",
    "mali":                        "faultlines_R17_Mali",
    "haiti-dominican-republic":    "faultlines_R20_Haiti-Dominica",
    "lebanon-israel":              "faultlines_R22_Lebanon-Israel",
    "cameroon":                    "faultlines_R23_Cameroon",
    "niger":                       "faultlines_R26_Niger",
    "ecuador":                     "faultlines_R28_Equador",
    "mozambique":                  "faultlines_R29_Mozambique",
    "iran-israel":                 "faultlines_R31_Iran-Israel",
    "usa-iran":                    "faultlines_R32_USA-Iran",
    "india-pakistan":              "faultlines_R35_India-Pakistan",
    "usa-venezuela":               "faultlines_R36_USA-Venezuela",
    "cambodia-thailand":           "faultlines_R42_Cambodia-Thailand",
    "serbia-kosovo":               "faultlines_R43_Serbia-Kosovo",
    "south-korea-north-korea":     "faultlines_R44_South-Korea-North-Korea",
    "cyprus-turkiye":              "faultlines_R45_Cyprus-Turkiye",
    "china-taiwan":                "faultlines_R46_China-Taiwan",
    "usa-cuba":                    "faultlines_R48_USA-Cuba",
    "usa-greenland":               "faultlines_R49_USA-Greenland",
    "usa-china":                   "faultlines_R50_USA-China",
    "china-india":                 "faultlines_R51_China-India"
  };

  function fileName(handle) {
    return FILE_MAP[handle] || handle;
  }

  const CONFLICTS = [
    { handle: "russia-ukraine",         a: "RUSSIA",         b: "UKRAINE",        year: "2014", name: "Russo-Ukrainian War" },
    { handle: "ethiopia-eritrea",       a: "ETHIOPIA",       b: "ERITREA",        year: "1998", name: "Eritrean-Ethiopian border conflict" },
    { handle: "yemen",                  a: "YEMEN",          internal: true,      year: "2014", name: "Yemeni Civil War" },
    { handle: "sudan",                  a: "SUDAN",          internal: true,      year: "2023", name: "Sudanese Civil War" },
    { handle: "syria",                  a: "SYRIA",          internal: true,      year: "2011", name: "Syrian Conflict" },
    { handle: "pakistan-afghanistan",   a: "PAKISTAN",       b: "AFGHANISTAN",    year: "1893 // 2021", name: "Pakistan\u2013Afghanistan border conflict" },
    { handle: "mexico",                 a: "MEXICO",         internal: true,      year: "2006", name: "Mexican Drug War" },
    { handle: "israel-palestine",       a: "ISRAEL",         b: "PALESTINE",      year: "1948", name: "Israeli-Palestinian conflict" },
    { handle: "nigeria",                a: "NIGERIA",        internal: true,      year: "2009", name: "Boko Haram insurgency" },
    { handle: "somalia",                a: "SOMALIA",        internal: true,      year: "1991", name: "Somali Civil War" },
    { handle: "myanmar",                a: "MYANMAR",        internal: true,      year: "1948 // 2021", name: "Myanmar Civil War" },
    { handle: "congo-rwanda",           a: "CONGO",          b: "RWANDA",         year: "2022", name: "Eastern DR Congo conflict (M23)" },
    { handle: "brazil",                 a: "BRAZIL",         internal: true,      year: "2006", name: "Brazilian Drug War" },
    { handle: "burkina",                a: "BURKINA_FASO",   internal: true,      year: "2015", name: "Sahel insurgency (Burkina Faso)" },
    { handle: "colombia",               a: "COLOMBIA",       internal: true,      year: "1964", name: "Colombian armed conflict" },
    { handle: "mali",                   a: "MALI",           internal: true,      year: "2012", name: "Sahel insurgency (Mali)" },
    { handle: "haiti-dominican-republic", a: "HAITI",        b: "DOMINICAN_REPUBLIC", year: "2021", name: "Haitian gang crisis" },
    { handle: "lebanon-israel",         a: "LEBANON",        b: "ISRAEL",         year: "1948 // 1982", name: "Israel\u2013Hezbollah conflict" },
    { handle: "cameroon",               a: "CAMEROON",       internal: true,      year: "2016", name: "Anglophone Crisis" },
    { handle: "niger",                  a: "NIGER",          internal: true,      year: "2015", name: "Sahel insurgency (Niger)" },
    { handle: "ecuador",                a: "ECUADOR",        internal: true,      year: "2021", name: "Ecuadorian narco-insurgency" },
    { handle: "mozambique",             a: "MOZAMBIQUE",     internal: true,      year: "2017", name: "Cabo Delgado insurgency" },
    { handle: "iran-israel",            a: "IRAN",           b: "ISRAEL",         year: "2024", name: "Iran\u2013Israel conflict" },
    { handle: "usa-iran",               a: "UNITED_STATES",  b: "IRAN",           year: "1979", name: "US\u2013Iran conflict" },
    { handle: "india-pakistan",         a: "INDIA",          b: "PAKISTAN",       year: "1947", name: "Kashmir conflict" },
    { handle: "usa-venezuela",          a: "UNITED_STATES",  b: "VENEZUELA",      year: "1999 // 2019", name: "US\u2013Venezuela crisis" },
    { handle: "cambodia-thailand",      a: "CAMBODIA",       b: "THAILAND",       year: "2025", name: "Cambodian\u2013Thai border conflict" },
    { handle: "serbia-kosovo",          a: "SERBIA",         b: "KOSOVO",         year: "1998 // 2008", name: "Serbia\u2013Kosovo dispute" },
    { handle: "south-korea-north-korea", a: "SOUTH_KOREA",   b: "NORTH_KOREA",    year: "1950", name: "Korean conflict" },
    { handle: "cyprus-turkiye",         a: "CYPRUS",         b: "TURKIYE",        year: "1974", name: "Cyprus dispute" },
    { handle: "china-taiwan",           a: "CHINA",          b: "TAIWAN",         year: "1949", name: "Cross-strait tension" },
    { handle: "usa-cuba",               a: "UNITED_STATES",  b: "CUBA",           year: "1959", name: "US\u2013Cuba tension" },
    { handle: "usa-greenland",          a: "UNITED_STATES",  b: "GREENLAND",      year: "2019 // 2025", name: "US\u2013Greenland dispute" },
    { handle: "usa-china",              a: "UNITED_STATES",  b: "CHINA",          year: "1949 // 2018", name: "US\u2013China rivalry" },
    { handle: "china-india",            a: "CHINA",          b: "INDIA",          year: "1962", name: "Sino-Indian border dispute" }
  ];

  /* code (e.g. "RUSSIA") -> translated display name.
     Falls back to the code itself, which is already valid
     English display text, if a translation key is missing. */
  function countryLabel(code) {
    if (!code) return code;
    return (S.countries && S.countries[code]) || code;
  }

  /* handle -> translated conflict name, falling back to the
     English "name" field carried in CONFLICTS itself. */
  function conflictName(c) {
    return (S.conflictNames && S.conflictNames[c.handle]) || c.name;
  }

  /* Country-pair label for UI chrome (dropdown rows/trigger):
     internal = single country, else "A / B" or "A / B / C",
     using translated country names. */
  function conflictLabel(c) {
    if (c.internal) return countryLabel(c.a);
    let s = countryLabel(c.a) + " / " + countryLabel(c.b);
    if (c.c) s += " / " + countryLabel(c.c);
    return s;
  }

  /* Richer label for cart/order details — country pair PLUS the
     conflict name, since "just appearing in cart" per the brief
     means the buyer (and Dario, reading the order) sees both the
     countries and what the conflict is actually called. */
  function cartConflictLabel(c) {
    return conflictLabel(c) + " \u2014 " + conflictName(c);
  }

  /* English-only versions of the above, bypassing T.countries /
     T.conflictNames entirely — used ONLY for the hidden "_EN"
     fulfillment properties, so Dario can read every order in English
     regardless of what language the customer bought in. c.a/b/c ARE
     already the English country words (they're also the lookup codes),
     and c.name is the guaranteed-English conflict name carried in the
     CONFLICTS array itself. */
  function conflictLabelEN(c) {
    if (c.internal) return c.a + " \u2014 " + c.name;
    let s = c.a + " / " + c.b;
    if (c.c) s += " / " + c.c;
    return s + " \u2014 " + c.name;
  }

  const COLOR_NAME_EN = {
    bone: "Ivory White",
    charcoal: "Charcoal Black",
    rainbow: "Rainbow"
  };

  /* Color option -> material hex. "rainbow" handled specially. */
  const COLOR_HEX = {
    bone: 0xFFFFFF, /* "Ivory White" per the locked Rings color reference — was
                        incorrectly using brand ivory (#EDE8DC) instead of the
                        actual filament color (#FFFFFF). Internal key stays
                        "bone" (matches data-color in the HTML); only the
                        color value changes. */
    charcoal: 0x1a1a1a,
    rainbow: 0xC8FF00 /* unused now — rainbow uses a reflective env map instead, see applyModelColor */
  };

  /* ---------- load JSON blobs ---------- */
  function readJSON(id, fallback) {
    const el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  const VARIANT_DATA = readJSON("flp-variant-data", { variants: [] });
  const S = readJSON("flp-strings", {
    placeholder: "\u2014 CHOOSE ONE \u2014",
    edgeLabel: "EDGE",
    viewerHint: "DRAG TO ROTATE",
    errorIncomplete: "Select conflict \u00B7 color \u00B7 height to continue",
    atcConfirm: "Noted. Move on.",
    addToCart: "ADD TO CART",
    cartUrl: "/cart",
    countries: {},
    conflictNames: {}
  });

  /* ---------- selection state ---------- */
  const state = {
    conflict: null,   /* handle */
    color: null,      /* bone | charcoal | rainbow */
    variantId: null,  /* height variant id */
    height: null      /* option1 label */
  };

  /* ============================================
     DROPDOWN (Zone 2)
     ============================================ */
  const trigger = document.getElementById("flpDropdownTrigger");
  const panel = document.getElementById("flpDropdownPanel");
  const list = document.getElementById("flpDropdownList");
  const label = document.getElementById("flpDropdownLabel");
  const closeBtn = document.getElementById("flpDropdownClose");

  function buildDropdownRows() {
    const frag = document.createDocumentFragment();
    /* Dropdown order: alphabetical by first country (a).
       This is a SEPARATE sorted copy — CONFLICTS itself is never
       mutated, so Page 1's grid order (defined conflict order,
       shared between both files) is completely unaffected. */
    const sorted = CONFLICTS.slice().sort(function (x, y) {
      return countryLabel(x.a).localeCompare(countryLabel(y.a));
    });
    sorted.forEach(function (c) {
      const row = document.createElement("button");
      row.type = "button";
      row.className = "flp-dropdown-row";
      row.setAttribute("role", "option");
      row.dataset.handle = c.handle;
      let names = conflictLabel(c);
      row.innerHTML =
        '<img class="flp-dropdown-row-thumb" src="' + THUMB_BASE + fileName(c.handle) + THUMB_SUFFIX + '" alt="" loading="lazy">' +
        '<span class="flp-dropdown-row-text">' + names + '</span>';
      row.addEventListener("click", function () {
        selectConflict(c);
        closeDropdown();
      });
      frag.appendChild(row);
    });
    list.appendChild(frag);
  }

  function isMobile() { return window.matchMedia("(max-width: 767px)").matches; }

  function openDropdown() {
    panel.hidden = false;
    if (isMobile()) panel.classList.add("is-open");
    trigger.setAttribute("aria-expanded", "true");
  }
  function closeDropdown() {
    panel.hidden = true;
    panel.classList.remove("is-open");
    trigger.setAttribute("aria-expanded", "false");
  }
  function toggleDropdown() {
    if (panel.hidden) openDropdown(); else closeDropdown();
  }

  function selectConflict(c) {
    state.conflict = c.handle;
    label.textContent = conflictLabel(c);
    label.style.color = "var(--color-ivory)";
    /* mark selected row */
    list.querySelectorAll(".flp-dropdown-row").forEach(function (r) {
      r.classList.toggle("is-selected", r.dataset.handle === c.handle);
    });
    const nameEl = document.getElementById("flpConflictName");
    if (nameEl) nameEl.textContent = conflictName(c) + (c.year ? " \u00B7 " + c.year : "");
    loadModel(c.handle);
    updateGate();
  }

  if (trigger) trigger.addEventListener("click", toggleDropdown);
  if (closeBtn) closeBtn.addEventListener("click", closeDropdown);
  /* click outside closes (desktop only) */
  document.addEventListener("click", function (e) {
    if (panel.hidden || isMobile()) return;
    if (!panel.contains(e.target) && !trigger.contains(e.target)) closeDropdown();
  });

  /* ============================================
     HEIGHT (Zone 5.5) — from real Shopify variants
     ============================================ */
  const heightRow = document.getElementById("flpHeightRow");
  const priceEl = document.getElementById("flpPrice");
  const variantIdInput = document.getElementById("flpVariantId");

  function buildHeightButtons() {
    if (!heightRow) return;
    VARIANT_DATA.variants.forEach(function (v) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "flp-height-btn";
      btn.textContent = v.option1; /* "12cm" etc. */
      btn.dataset.variantId = v.id;
      btn.dataset.price = v.priceFormatted;
      btn.addEventListener("click", function () {
        state.variantId = v.id;
        state.height = v.option1;
        variantIdInput.value = v.id;
        if (priceEl) priceEl.textContent = v.priceFormatted;
        heightRow.querySelectorAll(".flp-height-btn").forEach(function (b) {
          b.classList.toggle("is-selected", b === btn);
        });
        updateGate();
      });
      heightRow.appendChild(btn);
    });
  }

  /* ============================================
     COLOR (Zone 5) — live material swap on the model
     ============================================ */
  const swatches = document.querySelectorAll(".flp-swatch");
  const propColor = document.getElementById("flpPropColor");

  swatches.forEach(function (sw) {
    sw.addEventListener("click", function () {
      state.color = sw.dataset.color;
      if (propColor) propColor.value = sw.querySelector(".flp-swatch-name").textContent;
      swatches.forEach(function (s) { s.classList.toggle("is-selected", s === sw); });
      applyModelColor(state.color);
      updateGate();
    });
  });

  /* ============================================
     3D VIEWER (Zone 3) — Three.js via CDN
     drag-to-rotate only, live color swap, PNG fallback
     ============================================ */
  const viewerEl = document.getElementById("flpViewer");
  const fallbackImg = document.getElementById("flpViewerFallback");
  const emptyEl = document.getElementById("flpViewerEmpty");
  const hintEl = document.getElementById("flpViewerHint");

  let three = null;       /* { scene, camera, renderer, controls } */
  let currentModel = null;
  let webglOK = true;

  function webglSupported() {
    try {
      const c = document.createElement("canvas");
      return !!(window.WebGLRenderingContext &&
        (c.getContext("webgl") || c.getContext("experimental-webgl")));
    } catch (e) { return false; }
  }

  /* load three + loaders from CDN, then init */
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      const s = document.createElement("script");
      s.src = src; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  let threeReady = null;
  function ensureThree() {
    if (threeReady) return threeReady;
    threeReady = loadScript("https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js")
      .then(function () {
        return loadScript("https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/loaders/GLTFLoader.js");
      })
      .then(function () {
        return loadScript("https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/controls/OrbitControls.js");
      });
    return threeReady;
  }

  /* Generates a rainbow gradient, wraps it as a reflection environment,
     and PMREM-prefilters it so it blurs correctly with material
     roughness (same technique real product renderers use for shiny/
     iridescent surfaces — reflection-based, not a flat painted color). */
  /* ============================================
     PLA REALISM — layer lines + studio lighting
     ============================================

     Real print geometry this is matched to (confirmed by Dario):
       - 0.2mm layer height, 0.42mm wall width, 3 walls
       - not vase/spiral mode (standard walls)
       - ~24cm tall => ~1200 layers over the full vase

     Why this ISN'T drawn as 1200 literal stripes: at a typical
     ~600px render height that's ~2 layers per screen pixel, i.e.
     sub-pixel. Drawing them individually produces moire shimmer,
     not realism. Instead a high-frequency micro-normal texture is
     tiled densely (64 layers per tile x ~19 vertical repeats) and
     left to mipmapping + anisotropic filtering to average into a
     soft directional sheen at distance — which is exactly how the
     real vases read: layer lines present, but imperceptible unless
     you look closely. */

  const LAYER_TEX_LAYERS = 64;   /* layers encoded per texture tile */
  const LAYER_TEX_REPEAT_V = 19; /* vertical tiling => ~1200 total */

  /* Generates a normal map of fine horizontal ridges. Encoded in
     tangent space: R/G = XY normal deviation, B = up. Only G varies
     (vertical deviation) since layer lines only perturb the surface
     along the print axis. */
  function buildLayerNormalMap(THREE) {
    const w = 8;                      /* horizontal detail is uniform */
    const h = 512;                    /* 64 layers x 8px per layer */
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    const img = ctx.createImageData(w, h);

    const pxPerLayer = h / LAYER_TEX_LAYERS;

    for (let y = 0; y < h; y++) {
      /* position within the current layer, 0..1 */
      const t = (y % pxPerLayer) / pxPerLayer;
      /* Each extruded layer is a slightly rounded bead, so the surface
         normal tilts up over the bead then back down at the seam.
         sin gives that rounded profile; the seam (t near 0) is where
         two beads meet and the normal deviates most sharply. */
      const bead = Math.sin(t * Math.PI * 2);
      /* keep deviation small — these lines are subtle in reality */
      const gy = 0.5 + bead * 0.16;

      for (let x = 0; x < w; x++) {
        const i = (y * w + x) * 4;
        img.data[i]     = 128;                    /* R: no X deviation */
        img.data[i + 1] = Math.round(gy * 255);   /* G: Y deviation */
        img.data[i + 2] = 255;                    /* B: pointing out */
        img.data[i + 3] = 255;
      }
    }

    ctx.putImageData(img, 0, 0);

    const tex = new THREE.CanvasTexture(canvas);
    tex.wrapS = THREE.RepeatWrapping;
    tex.wrapT = THREE.RepeatWrapping;
    /* horizontal repeat stays low (surface is uniform around the vase);
       vertical repeat sets the real layer density */
    tex.repeat.set(1, LAYER_TEX_REPEAT_V);
    tex.needsUpdate = true;
    return tex;
  }

  /* Soft studio environment: a vertical gradient (bright above, dark
     below, subtle warm/cool split) generated in-canvas and PMREM-
     prefiltered. This is what gives believable edge falloff and soft
     reflections instead of the flat look of bare directional lights.
     No HDRI file to download — generated at runtime. */
  function buildStudioEnvMap(THREE, renderer) {
    /* 512 rather than 256 — reflections on the low-roughness clearcoat
       are visibly blockier at 256, and this is generated once per
       session so the cost is a one-off, not per-frame. */
    const size = 512;
    const canvas = document.createElement("canvas");
    canvas.width = size * 2;
    canvas.height = size;
    const ctx = canvas.getContext("2d");

    /* vertical gradient = sky/ceiling light above, floor bounce below */
    const grad = ctx.createLinearGradient(0, 0, 0, size);
    grad.addColorStop(0.0, "#ffffff");   /* overhead softbox */
    grad.addColorStop(0.35, "#dcd8d0");  /* upper falloff */
    grad.addColorStop(0.55, "#8a8a90");  /* horizon */
    grad.addColorStop(0.8, "#3a3a42");   /* lower falloff */
    grad.addColorStop(1.0, "#1a1a1e");   /* floor */
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, size * 2, size);

    /* Multi-softbox studio rig rather than a single highlight. Real
       product lighting uses several sources at different sizes and
       intensities; a lone highlight on a flat gradient is a big part
       of what makes generated environments look synthetic. Three
       sources here: large key (front-left), smaller fill (right),
       and a wide top strip standing in for an overhead softbox. */
    function softbox(cx, cy, r, alpha) {
      const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
      g.addColorStop(0, "rgba(255,255,255," + alpha + ")");
      g.addColorStop(0.5, "rgba(255,255,255," + (alpha * 0.35) + ")");
      g.addColorStop(1, "rgba(255,255,255,0)");
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, size * 2, size);
    }

    softbox(size * 0.55, size * 0.34, size * 0.55, 0.95);  /* key */
    softbox(size * 1.35, size * 0.42, size * 0.34, 0.45);  /* fill */
    softbox(size * 0.95, size * 0.10, size * 0.70, 0.35);  /* overhead */

    /* faint cool bounce from below — stops the underside going dead */
    const bounce = ctx.createLinearGradient(0, size * 0.82, 0, size);
    bounce.addColorStop(0, "rgba(120,130,160,0)");
    bounce.addColorStop(1, "rgba(120,130,160,0.22)");
    ctx.fillStyle = bounce;
    ctx.fillRect(0, 0, size * 2, size);

    const texture = new THREE.CanvasTexture(canvas);
    texture.mapping = THREE.EquirectangularReflectionMapping;
    texture.needsUpdate = true;

    const pmrem = new THREE.PMREMGenerator(renderer);
    pmrem.compileEquirectangularShader();
    const envRT = pmrem.fromEquirectangular(texture);
    pmrem.dispose();
    return envRT.texture;
  }

  function buildRainbowEnvMap(THREE, renderer) {
    const size = 256;
    const canvas = document.createElement("canvas");
    canvas.width = size * 2;
    canvas.height = size;
    const ctx = canvas.getContext("2d");
    const grad = ctx.createLinearGradient(0, 0, size * 2, 0);
    /* COPPER-DOMINANT, not full-spectrum rainbow. Confirmed against
       the real printed filament: it reads primarily as copper/bronze,
       with only occasional cooler iridescent glints as the angle
       shifts — not an even rainbow. Weighted roughly 70% warm
       copper/bronze/gold tones, with brief teal/violet/rose glints
       woven in at a few points rather than distributed evenly. */
    const stops = [
      "#5c3d1f", /* deep copper — darkened */
      "#8f5f2c", /* warm copper — darkened */
      "#b58e50", /* bronze-gold — darkened */
      "#8f5f2c", /* warm copper — darkened */
      "#3a6b64", /* cool iridescent glint — teal, kept close to original */
      "#734928", /* copper — darkened */
      "#5c3d1f", /* deep copper — darkened */
      "#5c3a68", /* cool iridescent glint — violet, kept close to original */
      "#8f5f2c", /* warm copper — darkened */
      "#b58e50", /* bronze-gold — darkened */
      "#5c3d1f"  /* deep copper (loop close) — darkened */
    ];
    stops.forEach(function (color, i) {
      grad.addColorStop(i / (stops.length - 1), color);
    });
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, size * 2, size);

    const texture = new THREE.CanvasTexture(canvas);
    texture.mapping = THREE.EquirectangularReflectionMapping;
    texture.needsUpdate = true;

    const pmrem = new THREE.PMREMGenerator(renderer);
    pmrem.compileEquirectangularShader();
    const envRT = pmrem.fromEquirectangular(texture);
    pmrem.dispose();
    return envRT.texture;
  }

  function initThree() {
    const THREE = window.THREE;
    const w = viewerEl.clientWidth;
    const h = viewerEl.clientHeight;

    const scene = new THREE.Scene();
    /* Explicit brand-black scene background, matching --color-black
       (#050505) exactly. Previously relied entirely on the canvas's
       alpha:true transparency showing the CSS backdrop through —
       that worked, but was indirect. Setting it directly here means
       the correct color holds even if the CSS background is ever
       changed independently, or during any transparency edge case. */
    scene.background = new THREE.Color(0x050505);
    /* Long lens (low FOV) + pulled-back camera. Product photography
       uses 85-135mm lenses; wide FOV is what gives 3D viewers that
       "video game" perspective distortion where near edges splay out.
       Dropping 35 -> 24 and moving the camera back preserves framing
       while flattening perspective the way a real product shot does.
       Free, and one of the single biggest perceptual wins available. */
    const camera = new THREE.PerspectiveCamera(24, w / h, 0.1, 100);
    camera.position.set(0, 0.25, 4.6);

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(w, h);

    /* Required for physically-based materials to look correct rather
       than washed out or blown out. ACES Filmic is the standard for
       product rendering — it rolls off highlights the way a camera
       does instead of clipping them flat white, which matters a lot
       for the bright ivory PLA. Guarded with feature checks since
       these property names moved between Three.js versions (this
       viewer loads r128 via CDN). */
    if (THREE.ACESFilmicToneMapping !== undefined) {
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.05;
    }
    if (THREE.sRGBEncoding !== undefined) {
      renderer.outputEncoding = THREE.sRGBEncoding;
    }
    if (renderer.physicallyCorrectLights !== undefined) {
      renderer.physicallyCorrectLights = true;
    }

    /* Shadow mapping. This is the cheapest route to the crevice
       darkening that real ambient occlusion provides: the vase's
       twisted folds self-shadow, which is a large part of what makes
       a form read as physical rather than flat-shaded. Full SSAO
       would need EffectComposer + extra CDN scripts and a per-frame
       post-processing pass — this gets most of the benefit for a
       fraction of the cost, since there is only one object in scene. */
    renderer.shadowMap.enabled = true;
    if (THREE.PCFSoftShadowMap !== undefined) {
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    }

    viewerEl.appendChild(renderer.domElement);

    /* lighting — post-dusk feel, soft */
    /* Lighting is now environment-map-driven (see buildStudioEnvMap),
       with direct lights reduced to a supporting role. The env map
       supplies ambient/reflection realism; these two lights just add
       definition and a crisp highlight the env map alone can't give.
       AmbientLight was REMOVED — with scene.environment set, an extra
       flat ambient term washes the form out and kills the soft
       shading that makes the print read as a physical object.
       Key stays front-dominant (near camera height/axis), not
       top-down, matching the earlier lighting correction. */
    /* Key light strengthened (0.65 -> 0.95) and fill tightened
       (0.22 -> 0.16) specifically for shadow/form definition on the
       matte materials (Ivory White, Charcoal Black). This is a safe
       shared change despite affecting all three colors: at
       metalness 0.8, the iridescent material's response to direct
       light is only ~20% of what a fully diffuse (metalness 0)
       surface receives — it is dominated by the environment
       reflection instead — so this reads as a large improvement on
       white/black and a barely perceptible one on iridescent.
       Shadow radius tightened (3 -> 2) for a more defined edge
       instead of an almost-invisible soft gradient. */
    const key = new THREE.DirectionalLight(0xffffff, 0.95);
    key.position.set(0.6, 0.6, 3.4);
    key.castShadow = true;
    key.shadow.mapSize.width = 1024;
    key.shadow.mapSize.height = 1024;
    key.shadow.camera.near = 0.5;
    key.shadow.camera.far = 12;
    key.shadow.camera.left = -2;
    key.shadow.camera.right = 2;
    key.shadow.camera.top = 2;
    key.shadow.camera.bottom = -2;
    key.shadow.bias = -0.003;       /* was -0.0015 — increased to reduce
                                        shadow-map acne risk, which the
                                        stronger key light + tighter radius
                                        made more likely on grazing-angle
                                        surfaces (exactly the top-edge
                                        geometry where the two profiles
                                        meet, per the known pipeline issue) */
    if (key.shadow.normalBias !== undefined) {
      key.shadow.normalBias = 0.02; /* further reduces acne on curved/
                                        angled surfaces, if supported */
    }
    key.shadow.radius = 2.5;        /* was 2 — pulled back slightly from
                                        the aggressive crisp setting toward
                                        a safer middle ground */
    scene.add(key);
    const fill = new THREE.DirectionalLight(0xbfc4d0, 0.16);
    fill.position.set(-1.4, 0.3, 1.6);
    scene.add(fill);
    /* Low rim light from behind — separates the silhouette from the
       dark background and catches the layer lines along the edges,
       which is where they're most visible on a real printed vase. */
    const rim = new THREE.DirectionalLight(0xffffff, 0.34);
    rim.position.set(-0.8, 1.2, -2.4);
    scene.add(rim);

    const controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableZoom = false;   /* drag to rotate ONLY */
    controls.enablePan = false;
    controls.enableDamping = true;
    controls.dampingFactor = 0.08;
    controls.autoRotate = true;
    controls.autoRotateSpeed = 0.9; /* slow, deliberate spin; higher = faster */
    controls.minPolarAngle = Math.PI * 0.15;
    controls.maxPolarAngle = Math.PI * 0.85;

    three = { scene: scene, camera: camera, renderer: renderer, controls: controls, THREE: THREE };

    /* Rainbow "iridescent PLA" reflection environment.
       Generated once per session, not per color-click. A true
       shifting-hue-by-angle look comes from REFLECTION, not a flat
       color or a static gradient painted on — this is how real
       iridescent/pearlescent filament actually reads under light.
       A canvas gradient is wrapped around the scene as a reflection
       source; a shiny material on the vase then reflects different
       parts of that gradient as the camera/vase rotates, which is
       genuine angle-dependent color shift, not a fake animated tint. */
    three.rainbowEnvMap = buildRainbowEnvMap(THREE, renderer);

    /* Studio environment for the solid PLA colors, and the shared
       layer-line normal map. Both generated once per session. */
    three.studioEnvMap = buildStudioEnvMap(THREE, renderer);
    three.layerNormalMap = buildLayerNormalMap(THREE);

    /* Anisotropic filtering keeps the dense layer lines from
       shimmering when the surface is viewed at a steep angle —
       essential given how fine the tiling is. */
    const maxAniso = renderer.capabilities.getMaxAnisotropy
      ? renderer.capabilities.getMaxAnisotropy()
      : 1;
    three.layerNormalMap.anisotropy = maxAniso;
    three.layerNormalMap.needsUpdate = true;

    /* Scene-wide environment so even un-swapped materials pick up
       realistic ambient reflection rather than flat shading. */
    scene.environment = three.studioEnvMap;

    /* Contact shadow — grounds the object so it doesn't float. */
    three.contactShadow = buildContactShadow(THREE, scene);

    function animate() {
      requestAnimationFrame(animate);
      controls.update();
      renderer.render(scene, camera);
    }
    animate();

    window.addEventListener("resize", onViewerResize);
  }

  function onViewerResize() {
    if (!three) return;
    const w = viewerEl.clientWidth;
    const h = viewerEl.clientHeight;
    three.camera.aspect = w / h;
    three.camera.updateProjectionMatrix();
    three.renderer.setSize(w, h);
  }

  function loadModel(handle) {
    const placeholder = document.getElementById("flpViewerPlaceholder");
    if (placeholder) placeholder.style.display = "none";
    if (emptyEl) emptyEl.style.display = "none";

    /* fallback path if WebGL unavailable */
    if (!webglOK) {
      showFallback(handle);
      return;
    }
    ensureThree().then(function () {
      if (!three) initThree();
      const THREE = window.THREE;
      const loader = new THREE.GLTFLoader();
      const url = GLB_URL[handle];
      if (!url) {
        /* no mapped GLB URL for this handle -> go straight to the
           PNG fallback rather than requesting a broken/guessed URL */
        showFallback(handle);
        return;
      }

      loader.load(url, function (gltf) {
        if (currentModel) { three.scene.remove(currentModel); }
        currentModel = gltf.scene;

        /* Orientation correction: the export pipeline appears to output
           Z-up geometry (common from Blender/custom pipelines), while
           Three.js/glTF viewers expect Y-up — without this, "front" and
           "top" swap, which is exactly the reported symptom. This is a
           best guess since the actual file wasn't directly inspected;
           if the vase still doesn't face front, try one of:
             Math.PI / 2   (90°, opposite direction)
             Math.PI       (180°, upside down)
             0             (no correction — original was already right) */
        currentModel.rotation.x = -Math.PI / 2;

        /* center + scale to fit — computed AFTER the rotation above,
           so the bounding box reflects the corrected orientation */
        const box = new THREE.Box3().setFromObject(currentModel);
        const size = box.getSize(new THREE.Vector3());
        const center = box.getCenter(new THREE.Vector3());
        currentModel.position.sub(center);
        const maxDim = Math.max(size.x, size.y, size.z) || 1;
        const scale = 1.8 / maxDim;
        currentModel.scale.setScalar(scale);

        three.scene.add(currentModel);

        /* Sit the contact shadow at the base of the model, scaled to
           the vase's actual footprint so the shadow reads as belonging
           to this specific silhouette rather than a generic blob. */
        if (three.contactShadow) {
          const scaledBox = new THREE.Box3().setFromObject(currentModel);
          const scaledSize = scaledBox.getSize(new THREE.Vector3());
          three.contactShadow.position.y = scaledBox.min.y - 0.01;
          const footprint = Math.max(scaledSize.x, scaledSize.z) * 1.6;
          three.contactShadow.scale.setScalar(footprint / 2.6);
        }

        if (emptyEl) emptyEl.style.display = "none";
        if (hintEl) hintEl.hidden = false;

        /* apply currently selected color, if any */
        if (state.color) applyModelColor(state.color);
      }, undefined, function (err) {
        /* model failed to load -> fallback to thumbnail */
        showFallback(handle);
      });
    }).catch(function () {
      webglOK = false;
      showFallback(handle);
    });
  }

  /* Per-color PLA material profiles, tuned to how each filament
     actually behaves under light rather than one generic plastic:

     IVORY WHITE — the most translucent. Light penetrates ~1-2mm and
       scatters back out, which is why real white PLA looks soft and
       slightly luminous at thin walls/rims instead of chalky. Faked
       with MeshPhysicalMaterial transmission + thickness (true
       subsurface scattering is far too expensive for a web viewer).
       Kept deliberately low — white PLA is slightly translucent,
       not glass; overdoing this is the classic tell of a fake render.

     CHARCOAL BLACK — near-opaque, absorbs most light, so it reads
       matte with a tight specular roll-off. Higher roughness, no
       transmission, and a slightly stronger clearcoat since dark PLA
       tends to show surface sheen more visibly than white.

     Both share the layer-line normal map and the studio environment. */
  /* Viewer backdrop per color — see applyModelColor / VIEWER_BG below.
     A true matte black is very hard to read against a near-black
     scene: real product photography puts dark subjects on a LIGHTER
     ground specifically so the silhouette reads by contrast rather
     than by relying on subtle specular detail alone. */
  const VIEWER_BG = {
    bone: 0x050505,
    charcoal: 0xEDE4D3,  /* warm light beige, not pure white — reads as
                             a studio backdrop, not a color-picker swap */
    rainbow: 0x050505
  };

  const PLA_PROFILES = {
    bone: {
      /* IVORY WHITE — pulled noticeably warmer/beiger. The previous
         value (0xF4F1EA) still rendered as near-stark-white once the
         bright studio softbox and clearcoat specular were added on
         top of it. This sits close to the brand's own ivory reference
         (#EDE8DC) rather than a generic "warm white". */
      color: 0xE6DCC4,
      roughness: 0.55,
      metalness: 0.0,
      clearcoat: 0.18,        /* reduced — less bright specular lift */
      clearcoatRoughness: 0.5,
      transmission: 0.05,
      thickness: 1.6,
      normalScale: 0.55,
      envMapIntensity: 0.8    /* reduced — less ambient brightening from the env */
    },
    charcoal: {
      /* CHARCOAL BLACK — was reading as light grey. Two compounding
         causes: clearcoat (0.35) added a bright specular layer on
         top regardless of base color, and scene.environment (added
         for realism) contributes ambient/diffuse light to every
         material globally, which lifts a dark diffuse surface much
         more than expected. Fixed by cutting clearcoat hard, raising
         clearcoatRoughness so what little remains scatters instead
         of glossing, dropping envMapIntensity substantially, and
         darkening the base color itself. Paired with the lighter
         VIEWER_BG above so it still reads as "black" by silhouette
         contrast rather than needing to fight a near-black backdrop. */
      color: 0x121214,
      roughness: 0.82,
      metalness: 0.0,
      clearcoat: 0.10,
      clearcoatRoughness: 0.8,
      transmission: 0.0,
      thickness: 0,
      normalScale: 0.75,
      envMapIntensity: 0.35
    }
  };

  /* ============================================
     RUNTIME UV GENERATION
     ============================================
     VERIFIED against all 35 exported GLBs: they contain ONLY
     POSITION and COLOR_0 attributes — no TEXCOORD_0 (UVs) and no
     NORMAL. Without UVs a normal map has nothing to map onto and
     the layer lines simply would not render at all.

     Rather than require a change to the Python export pipeline,
     UVs are generated here at load time using a cylindrical
     projection, which is exactly the right projection for a vase:
       U = angle around the vertical axis (0..1)
       V = normalized height (0..1)
     This makes the layer-line normal map wrap around the form and
     stack correctly up its height, matching how the real print is
     laid down layer by layer.

     (If the export pipeline ever does start emitting UVs, this
     becomes redundant but harmless — it would simply overwrite
     them with an equivalent projection.) */
  function generateCylindricalUVs(THREE, geometry) {
    const pos = geometry.attributes.position;
    if (!pos) return;

    geometry.computeBoundingBox();
    const bb = geometry.boundingBox;

    /* CRITICAL: the export pipeline outputs Z-UP geometry, not Y-up.
       Verified from the GLB bounding box: X +/-61, Y +/-42, Z +/-120
       — the vase's height runs along Z. An earlier version of this
       function assumed Y was the height axis, which wrapped the
       layer-line texture in completely the wrong direction and
       produced artificial-looking streaking.

       Rather than hardcode Z, the longest axis is detected, so this
       stays correct even if the pipeline's orientation ever changes. */
    const sx = bb.max.x - bb.min.x;
    const sy = bb.max.y - bb.min.y;
    const sz = bb.max.z - bb.min.z;

    let upAxis = "z";
    if (sy >= sx && sy >= sz) upAxis = "y";
    else if (sx >= sy && sx >= sz) upAxis = "x";

    const getters = {
      x: { h: (i) => pos.getX(i), a: (i) => pos.getY(i), b: (i) => pos.getZ(i), min: bb.min.x, size: sx || 1 },
      y: { h: (i) => pos.getY(i), a: (i) => pos.getZ(i), b: (i) => pos.getX(i), min: bb.min.y, size: sy || 1 },
      z: { h: (i) => pos.getZ(i), a: (i) => pos.getX(i), b: (i) => pos.getY(i), min: bb.min.z, size: sz || 1 }
    };
    const g = getters[upAxis];

    const uvs = new Float32Array(pos.count * 2);

    for (let i = 0; i < pos.count; i++) {
      /* angle around the height axis -> U (wraps around the vase) */
      const u = (Math.atan2(g.b(i), g.a(i)) / (Math.PI * 2)) + 0.5;
      /* position along the height axis -> V (stacks up the vase,
         which is the direction the layers are actually printed) */
      const v = (g.h(i) - g.min) / g.size;

      uvs[i * 2] = u;
      uvs[i * 2 + 1] = v;
    }

    geometry.setAttribute("uv", new THREE.BufferAttribute(uvs, 2));
    geometry.attributes.uv.needsUpdate = true;
  }

  /* Grounding: a soft contact shadow beneath the vase. Without this
     the object floats in a void, which is the single strongest "this
     is CGI" signal in a product render — real objects sit on things
     and occlude light beneath them. Implemented as a radial-gradient
     sprite on a horizontal plane rather than a real shadow map: far
     cheaper, and for a single centred object on a dark background it
     is visually indistinguishable from the real thing. */
  function buildContactShadow(THREE, scene) {
    const size = 256;
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext("2d");

    const grad = ctx.createRadialGradient(
      size / 2, size / 2, 0,
      size / 2, size / 2, size / 2
    );
    grad.addColorStop(0.0, "rgba(0,0,0,0.55)");
    grad.addColorStop(0.35, "rgba(0,0,0,0.28)");
    grad.addColorStop(0.7, "rgba(0,0,0,0.07)");
    grad.addColorStop(1.0, "rgba(0,0,0,0)");
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, size, size);

    const tex = new THREE.CanvasTexture(canvas);
    tex.needsUpdate = true;

    const mat = new THREE.MeshBasicMaterial({
      map: tex,
      transparent: true,
      depthWrite: false,
      opacity: 0.9
    });

    const mesh = new THREE.Mesh(new THREE.PlaneGeometry(2.6, 2.6), mat);
    mesh.rotation.x = -Math.PI / 2;   /* lay flat */
    mesh.renderOrder = -1;            /* draw before the vase */
    scene.add(mesh);
    return mesh;
  }

  function applyModelColor(color) {
    if (!three || !currentModel) return;
    const THREE = window.THREE;

    /* Swap the viewer backdrop to match the selected color — brand
       black for white/rainbow, warm light beige for charcoal so the
       "black" reads by silhouette contrast instead of fighting a
       near-black background. Both the Three.js scene background and
       the CSS box behind the canvas are updated together so there is
       no mismatched edge between them. */
    const bgHex = VIEWER_BG[color] != null ? VIEWER_BG[color] : VIEWER_BG.bone;
    three.scene.background = new THREE.Color(bgHex);
    if (viewerEl) {
      viewerEl.style.background = "#" + bgHex.toString(16).padStart(6, "0");
    }

    currentModel.traverse(function (node) {
      if (!node.isMesh) return;

      if (node.geometry) {
        /* The exported GLBs contain ONLY POSITION and COLOR_0 —
           verified across all 35 files. No NORMAL, no TEXCOORD_0.
           Both must therefore be generated here at load time:
             - normals: without them there is nothing for lighting to
               work against and the mesh renders black
             - UVs: without them the layer-line normal map has nothing
               to map onto and would not render at all */
        node.geometry.computeVertexNormals();
        generateCylindricalUVs(THREE, node.geometry);
      }

      if (color === "rainbow") {
        /* Reflects the generated rainbow environment (see
           buildRainbowEnvMap, now copper-dominant). Base color tinted
           warm copper rather than pure white — a white base under a
           mirror-strength reflection was part of what read as "too
           flashy/crazy" versus the real printed material, which has
           its own warm base tone with iridescent glints riding on
           top of it, not a chrome surface reflecting a rainbow.
           Roughness raised slightly (0.18 -> 0.26) for a satin sheen
           rather than a hard mirror. Different parts of the vase
           still reflect different tones from the gradient, and that
           shifts for real as the vase auto-rotates — genuine angle-
           dependent color, not a static tint. Layer lines still
           applied: the iridescent filament is printed the same way
           as any other. */
        node.material = new THREE.MeshStandardMaterial({
          color: 0x7A4E2C,  /* darker copper, was 0xB87A4A */
          metalness: 0.8,
          roughness: 0.26,
          envMap: three.rainbowEnvMap || null,
          envMapIntensity: 1.0,  /* was 1.15 — slightly less bright reflection to match */
          normalMap: three.layerNormalMap || null,
          vertexColors: false,
          side: THREE.DoubleSide
        });
        if (node.material.normalMap) {
          node.material.normalScale = new THREE.Vector2(0.5, 0.5);
        }
      } else {
        const p = PLA_PROFILES[color] || PLA_PROFILES.bone;

        /* MeshPhysicalMaterial (not MeshStandardMaterial) — needed for
           clearcoat and transmission, which are what separate "generic
           plastic object" from "this specific printed material". */
        node.material = new THREE.MeshPhysicalMaterial({
          color: p.color,
          roughness: p.roughness,
          metalness: p.metalness,
          clearcoat: p.clearcoat,
          clearcoatRoughness: p.clearcoatRoughness,
          transmission: p.transmission,
          thickness: p.thickness,
          ior: 1.46,               /* PLA's real index of refraction */
          envMap: three.studioEnvMap || null,
          envMapIntensity: p.envMapIntensity,
          normalMap: three.layerNormalMap || null,
          /* Exports carry a COLOR_0 vertex-color attribute. Left
             enabled it would tint the chosen PLA color unpredictably,
             so it is explicitly ignored — the swatch selection is the
             single source of truth for color. */
          vertexColors: false,
          side: THREE.DoubleSide
        });

        if (node.material.normalMap) {
          node.material.normalScale = new THREE.Vector2(p.normalScale, p.normalScale);
        }
      }

      node.material.needsUpdate = true;

      /* Self-shadowing: the twisted form shadows its own folds, which
         is where most of the perceived depth comes from. */
      node.castShadow = true;
      node.receiveShadow = true;
    });
  }

  function showFallback(handle) {
    if (!fallbackImg) return;
    fallbackImg.src = THUMB_BASE + fileName(handle) + THUMB_SUFFIX;
    fallbackImg.hidden = false;
    if (emptyEl) emptyEl.style.display = "none";
    if (three && three.renderer && three.renderer.domElement) {
      three.renderer.domElement.style.display = "none";
    }
  }

  /* ============================================
     ADD TO CART GATING (Zone 6) — 3 selectors
     ============================================ */
  const atc = document.getElementById("flpAtc");
  const atcError = document.getElementById("flpAtcError");
  const atcConfirm = document.getElementById("flpAtcConfirm");
  const form = document.getElementById("flpForm");
  const propConflict = document.getElementById("flpPropConflict");

  function complete() {
    return state.conflict && state.color && state.variantId;
  }

  function updateGate() {
    const ok = complete();
    if (atc) atc.disabled = !ok;
    if (atcError) atcError.classList.toggle("is-hidden", ok);
    /* write conflict property (human-readable) — includes both the
       country pair AND the conflict name, per explicit request that
       both must be visible in cart/order details, not just countries */
    if (propConflict && state.conflict) {
      const c = CONFLICTS.find(function (x) { return x.handle === state.conflict; });
      if (c) propConflict.value = cartConflictLabel(c);
    }
  }

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!complete()) { updateGate(); return; }

      const payload = {
        id: state.variantId,
        quantity: 1,
        properties: {}
      };
      const c = CONFLICTS.find(function (x) { return x.handle === state.conflict; });
      if (c) payload.properties["Conflict"] = cartConflictLabel(c);
      const selSwatch = document.querySelector(".flp-swatch.is-selected .flp-swatch-name");
      if (selSwatch) payload.properties["Color"] = selSwatch.textContent;
      /* Height is already the real Shopify variant (state.variantId),
         so it appears natively via the variant title in cart/checkout.
         Also sent as an explicit property so it's guaranteed visible
         even if the cart template doesn't render variant titles
         generically for every product. */
      if (state.height) payload.properties["Height"] = state.height;

      /* Dual-property pattern (per translation doc build note): hidden
         English-language values alongside the customer-visible translated
         ones, for admin/fulfillment reading regardless of what language
         the customer bought in. Underscore prefix keeps these hidden from
         the customer-facing cart, matching cart.main.liquid's existing
         convention (it skips any property key starting with "_").
         NAMING FLAG: this mirrors the pattern described for Rings'
         color/finish, but the exact key format (case, suffix style) was
         not visible from this chat — if Rings uses a different exact
         convention (e.g. "_color_en" vs "_Color_EN"), tell me and I'll
         match it exactly rather than introduce a second convention. */
      if (c) payload.properties["_Conflict_EN"] = conflictLabelEN(c);
      if (state.color) payload.properties["_Color_EN"] = COLOR_NAME_EN[state.color] || state.color;
      if (state.height) payload.properties["_Height_EN"] = state.height; /* variant option text; not currently translated */

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      }).then(function () {
        if (atcConfirm) atcConfirm.hidden = false;
        if (atcError) atcError.classList.add("is-hidden");
        /* update cart count in nav if present */
        setTimeout(function () { window.location.href = S.cartUrl; }, 700);
      }).catch(function () {
        if (atcError) {
          atcError.textContent = S.errorIncomplete;
          atcError.classList.remove("is-hidden");
        }
      });
    });
  }

  /* ============================================
     INIT + deep-link (?conflict=handle from Page 1 tiles)
     ============================================ */
  function preselectFromURL() {
    const params = new URLSearchParams(window.location.search);
    const h = params.get("conflict");
    if (!h) return;
    const c = CONFLICTS.find(function (x) { return x.handle === h; });
    if (c) selectConflict(c);
  }

  document.addEventListener("DOMContentLoaded", function () {
    webglOK = webglSupported();
    buildDropdownRows();
    buildHeightButtons();
    updateGate();
    preselectFromURL();
  });

})();